import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash
      }
    }
  },
  routes: [
    {
      path: '/(ru/)?',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/main-page/Main')
    },
    {
      path: '/(ru/)?confirm-social/',
      name: 'confirmSocial',
      component: () => import(/* webpackChunkName: "confirm-social" */ './views/ConfirmSocial')
    },
    {
      path: '/(ru/)?cabinet/',
      name: 'cabinet',
      component: () => import(/* webpackChunkName: "cabinet" */ './views/cabinet/Cabinet'),
      children: [
        {
          path: '',
          name: 'cabinet-home',
          component: () => import(/* webpackChunkName: "cabinet-home" */ './views/cabinet/pages/CabinetBonuses')
        },
        {
          path: 'settings',
          name: 'cabinet-settings',
          component: () => import(/* webpackChunkName: "cabinet-settings" */ './views/cabinet/pages/CabinetSettings')
        },
        {
          path: 'wishlist',
          name: 'cabinet-wishlist',
          component: () => import(/* webpackChunkName: "cabinet-wishlist" */ './views/cabinet/pages/CabinetWishlist')
        },
        {
          path: 'waitlist',
          name: 'cabinet-waitlist',
          component: () => import(/* webpackChunkName: "cabinet-waitlist" */ './views/cabinet/pages/CabinetWaitlist')
        },
        {
          path: 'viewed-products',
          name: 'cabinet-viewed-products',
          component: () => import(/* webpackChunkName: "cabinet-viewed-products" */ './views/cabinet/pages/CabinetViewedProducts')
        },
        {
          path: 'warranty',
          name: 'cabinet-warranty',
          component: () => import(/* webpackChunkName: "cabinet-warranty" */ './views/cabinet/pages/CabinetWarranty'),
          beforeEnter: (to, from, next) => {
            if (window.config && !window.config.show_tool_registration_page) {
              next({ name: 'cabinet-home' })
            } else {
              next()
            }
          }
        },
        {
          path: 'orders',
          name: 'cabinet-orders',
          component: () => import(/* webpackChunkName: "cabinet-order-history" */ './views/cabinet/pages/CabinetOrderHistory')
        },
        {
          path: 'promo',
          name: 'cabinet-promo',
          component: () => import(/* webpackChunkName: "cabinet-promo" */ './views/cabinet/pages/CabinetPromo')
        },
        {
          path: 'workshop',
          name: 'cabinet-workshop',
          component: () => import(/* webpackChunkName: "cabinet-workshop" */ './views/cabinet/pages/CabinetWorkshop')
        },
        {
          path: 'communications',
          name: 'cabinet-communications',
          component: () => import(/* webpackChunkName: "cabinet-communications" */ './views/cabinet/pages/CabinetCommunications')
        },
        {
          path: '*',
          redirect: to => {
            return '/(ru/)?cabinet/'
          }
        }
      ]
    },
    {
      path: '/(ru/)?checkout/',
      name: 'checkout',
      component: () => import(/* webpackChunkName: "checkout" */ './views/checkout-new/CheckoutNew'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?manager-checkout/',
      name: 'manager-checkout',
      component: () => import(/* webpackChunkName: "checkout" */ './views/checkout-new/CheckoutNew')
    },
    {
      path: '/(ru/)?checkout/success/',
      name: 'checkout-success',
      component: () => import(/* webpackChunkName: "checkout-success" */ './views/checkout/ThankYouPage'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?contact/',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/contact-page/Contact')
    },
    {
      path: '/(ru/)?login/',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/login-page/Login')
    },
    {
      path: '/(ru/)?site/quality/',
      name: 'quality',
      component: () => import(/* webpackChunkName: "quality" */ './views/quality-control-page/QualityControl')
    },
    {
      path: '/(ru/)?seasonal/',
      name: 'garden',
      component: () => import(/* webpackChunkName: "garden" */ './views/garden-page/Garden')
    },
    {
      path: '/(ru/)?comparison/',
      name: 'comparison',
      component: () => import(/* webpackChunkName: "comparison" */ './views/comparison-page/ProductComparison')
    },
    {
      path: '/(ru/)?poll/:id/',
      name: 'poll',
      component: () => import(/* webpackChunkName: "poll" */ './views/quality-control-page/QualityControl')
    },
    {
      path: '/(ru/)?poll/fm/:id/',
      name: 'poll-fm',
      component: () => import(/* webpackChunkName: "poll-fm" */ './views/quality-control-page/QualityControl'),
      props: {
        isPollFm: true
      }
    },
    {
      path: '/(ru/)?catalog/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ './views/search-page/Search')
    },
    {
      path: '/(ru/)?lovestory',
      name: 'lovestory',
      component: () => import(/* webpackChunkName: "valentines-day" */ './views/landings/ValentinesDay'),
      props: { isAjaxAuth: true }
    },
    // {
    //   path: '/(ru/)?black-friday',
    //   name: 'black-friday',
    //   // component: () => import(/* webpackChunkName: "black-friday" */ './views/landings/black-friday/Index')
    //   component: () => import(/* webpackChunkName: "black-friday" */ './views/landings/BlackFriday')
    // },
    {
      path: '/(ru/)?mail-to-dnipro-m',
      name: 'mail-to-santa',
      component: () => import(/* webpackChunkName: "mail-to-santa" */ './views/landings/MailToSanta'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?500-saloniv-majsternosti',
      name: '500-saloniv-majsternosti',
      component: () => import(/* webpackChunkName: "wheel-of-fortune" */ './views/landings/WheelOfFortune'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?franchise',
      name: 'franchise',
      component: () => import(/* webpackChunkName: "franchise" */ './views/landings/franchise/Index'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?franchise-chugaister',
      name: 'franchise-chugaister',
      component: () => import(/* webpackChunkName: "franchise" */ './views/landings/franchise/Index'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?comments',
      name: 'comments',
      component: () => import(/* webpackChunkName: "comments" */ './views/comments-page/Comments'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?career',
      name: 'career',
      component: () => import(/* webpackChunkName: "career" */ './views/landings/CareerNew')
    },
    {
      path: '/(ru/)?league-of-masters',
      name: 'league-of-masters',
      component: () => import(/* webpackChunkName: "league-of-masters" */ './views/landings/LeagueOfMasters'),
      props: { isAjaxAuth: true }
    },
    {
      path: '/(ru/)?sadovyy-yarmarok',
      name: 'sadovyy-yarmarok',
      component: () => import(/* webpackChunkName: "sadovyy-yarmarok" */ './views/landings/SadovyyYarmarok'),
      props: { isAjaxAuth: true }
    }
  ]
})
